export default function device(device) {
  return {
    getWidth: function() {
      if (device === 'mobile') {
        return 330
      }

      return 380
    },
    getPadding: function() {
      if (device === 'mobile') {
        return 15
      }

      return 35
    }
  }
}



// WEBPACK FOOTER //
// ./src/components/Login/helper/device.js